import {
  BRAND_LIST_PAGE_PATH,
  BRAND_PAGE_PATH,
  LARGE_CATEGORY_PAGE_PATH,
  MIDDLE_CATEGORY_PAGE_PATH,
  SEARCH_PAGE_PATH,
  SMALL_CATEGORY_PAGE_PATH,
  TINY_CATEGORY_PAGE_PATH
} from 'src/constants/pagePath';
import { LOCALE_TYPE } from 'src/types/locale';

export const generateQuestionnaireURL = (locale: LOCALE_TYPE) => {
  const localeMap = {
    [LOCALE_TYPE.JA]: '9C9QP7Z',
    [LOCALE_TYPE.TW]: '9C9QP7Z',
    [LOCALE_TYPE.HK]: 'GXN8N6M',
    [LOCALE_TYPE.CN]: 'FRSKMLH',
    [LOCALE_TYPE.EN]: 'GXHBFV3'
  };
  return `https://jp.surveymonkey.com/r/${localeMap[locale]}`;
};

export const questionnairePopupDisplayedPage = [
  LARGE_CATEGORY_PAGE_PATH,
  MIDDLE_CATEGORY_PAGE_PATH,
  SMALL_CATEGORY_PAGE_PATH,
  TINY_CATEGORY_PAGE_PATH,
  BRAND_LIST_PAGE_PATH,
  BRAND_PAGE_PATH,
  SEARCH_PAGE_PATH
];
